import render from 'preact-render-to-string';
import { useEffect, useState } from 'preact/hooks';
import Table from "../components/ui/Table";
import Modal from '../components/ui/Modal';
import useTable from '../context/TableContext';
import useApp from '../context/AppContext';
import useModal from '../hooks/useModal';
import ActionButton from '../components/ui/ActionButton';
import SelectAuto from '../components/ui/SelectAuto';
import Select from '../components/ui/Select';
import { Link, route } from 'preact-router';
import { getAge, getRemainingDays } from '../functions';
import { sexItems, sexArray, weightList, birthdayList } from '../consts';

export default function AnimalsList() {
    const [isLoading, setLoading] = useState(true);
    const { animals } = useApp();
    const { isModalShowing, toggleModal } = useModal();
    const { markers, eventsType } = useApp();
    const {
        tableData,
        tableDataDisplay,
        handleDisplaying,
        tableActions,
        setTableActions,
        setFilter,
        cancelFilters
    } = useTable();
    const [selectedAnimal, setSelectedAnimal] = useState(null);
    const [selectedMarkers, setSelectedMarkers] = useState(null);
    const [selectedSex, setSelectedSex] = useState(null);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedBirthday, setSelectedBirthday] = useState(null);
    const [selectedWeight, setSelectedWeight] = useState(null);
    const [selectedNumber, setSelectedNumber] = useState(null);
    const [animalList, setAnimalList] = useState([]);
    const [animalNameFilter, setAnimalNameFilter] = useState("");

    const columns = [
        { label: "Nom", accessor: "name", sortable: true },
        { label: "Sexe", accessor: "sex", sortable: true },
        { label: "Terrain", accessor: "location", sortable: false },
        { label: "Age", accessor: "birthday", sortable: true },
        { label: "Poids", accessor: "weight", sortable: true },
        { label: "T.A.", accessor: "wt_meat", sortable: false },
    ];

    function cellFormat(value, accessor, data) {
        let str = value;
        switch (accessor) {
            case 'name':
                str = render(<Link href={'/animal/' + data.id}>{value}</Link>);
                data.markers.forEach(marker => {
                    str += '<div class="marker-shape" style="background-color:' + marker.color + '"></div>';
                })
                if (data.exited) {
                    str = '<div class="exited">' + str + '</div>';
                }
                break;
            case 'sex':
                str = sexItems[value];
                break;
            case 'birthday':
                str = getAge(value);
                break;
            case 'location':
                str = <Link className="nav-animal" href={'/location/' + value.id}><div dangerouslySetInnerHTML={{ __html: value.name }} /></Link>
                str = render(str);
                break;
            case 'wt_meat':
                if (!data.wt_meat && !data.wt_milk) {
                    str = null;
                }
                else {
                    data.wt_milk = data.wt_milk ? data.wt_milk : 0;
                    data.wt_meat = data.wt_meat ? data.wt_meat : 0;
                    str = getRemainingDays(data.wt_date, Math.max(data.wt_milk, data.wt_meat))
                    if (str < 0) str = "0";
                }
                break;
            default:
        }
        return str;
    }

    function gotoMovement() {
        route('/event-movement');
    }

    function gotoMarker() {
        route('/event-marker');
    }

    function gotoExit() {
        route('/event-exit');
    }

    function gotoOther() {
        route('/event-other');
    }

    useEffect(() => {
        const filteredFields = tableActions.animals.filteredFields;
        setSelectedAnimal(filteredFields.id);
        setSelectedMarkers(filteredFields.markers);
        setSelectedSex(filteredFields.sex);
        setSelectedLocation(filteredFields['location.id']);
        setSelectedBirthday(filteredFields.birthday);
        setSelectedWeight(filteredFields.weight);
        setSelectedNumber(filteredFields.number);
        setLoading(false);

        // On unmount
        return () => {
            sessionStorage.scrollTopAnimalList = sessionStorage.scrollTop;
        }
    }, []);

    useEffect(() => {
        if (!isLoading) {
            const scrollTop = sessionStorage.scrollTopAnimalList || 0;
            document.documentElement.scrollTo(0, scrollTop);
        }
    }, [isLoading]);

    useEffect(() => {
        handleDisplaying('animals');
    }, [tableData]);

    const buttonModalFilterCancel = {
        className: "btn-secondary",
        text: "Annuler les filtres",
        onClick: () => {
            cancelFilters('animals');
            setSelectedAnimal('');
            setAnimalList([]);
            setAnimalNameFilter('');
            setSelectedMarkers('');
            setSelectedSex('');
            setSelectedLocation('');
            setSelectedBirthday('');
            setSelectedWeight('');
            setSelectedNumber('');
            toggleModal('ModalFilter');
        }
    }

    const buttonModalFilter = {
        className: "btn-primary",
        text: "Filtrer",
        onClick: () => {
            setTableActions({
                ...tableActions,
                animals: {
                    ...tableActions.animals,
                    pager: {
                        ...tableActions.animals.pager,
                        page: 1
                    }
                }
            });
            toggleModal('ModalFilter');
        }
    }

    const handleAnimalFilterInSelect = (e) => {
        const value = e.target.value;
        setAnimalNameFilter(e.target.value);
        const animalListFiltered = animals.filter((animal) => {
            const animalName = animal.name.substring(0, value.length);
            return value.toLowerCase() == animalName.toLowerCase()
        })
        if (typeof animalListFiltered != "undefined") {
            setAnimalList(animalListFiltered);
        }
    }

    const handleInputChange = (e, field) => {
        const value = e.target.value;
        setFilter('animals', field, value);
        switch (field) {
            case 'id':
                setSelectedAnimal(value);
                break;
            case 'markers':
                setSelectedMarkers(value);
                break;
            case 'sex':
                setSelectedSex(value);
                break;
            case 'location.id':
                setSelectedLocation(value);
                break;
            case 'birthday':
                setSelectedBirthday(value);
                break;
            case 'weight':
                setSelectedWeight(value);
                break;
            case 'number@text-end':
                setSelectedNumber(value);
                break;
        }
    }

    const handleEventsTypeChange = (e) => {
        route('/event-other/type/' + e.target.value);
    }


    if (typeof tableData.animals == 'undefined' || tableData === null || tableDataDisplay === null || tableDataDisplay.animals == 'undefined' || !markers) {
        return <div className="text-center pt-5">Loading animals ...</div>;

    }

    if (isLoading) {
        return <div className="App">Loading ...</div>;
    }

    return (
        <div>
            <Table id="animals" caption="Liste des animaux" columns={columns} selectable={['sex', 'birthday', 'weight', 'wt']} cellFormat={cellFormat} filter={{ filterable: true, toggleModal: () => toggleModal('ModalFilter') }} pagination={false} />
            <Modal isShowing={isModalShowing} hide={() => toggleModal('ModalFilter')} title="Choisissez une action" id="ModalFilter" buttons={[buttonModalFilterCancel, buttonModalFilter]}>
                <div>
                    <div class="form-floating mb-2">
                        <input class="form-control" id="number@text-end" type="text" placeholder="-" value={selectedNumber} onChange={(e) => handleInputChange(e, 'number@text-end')} />
                        <label class="form-label" for="number@text-end">Filtrer par numéro de boucle</label>
                    </div>
                    <SelectAuto id="animal" label="Filtrer par animal" value={selectedAnimal} onChange={(e) => handleInputChange(e, 'id')} filter={animalNameFilter} onFilter={handleAnimalFilterInSelect} >
                        <option value="">- Choisissez -</option>
                        {
                            animalList && animalList.map((animal) => {
                                return (
                                    <option key={animal.id} selected={selectedAnimal === animal.id && true || false} value={animal.id}>{animal.name}</option>
                                )
                            })
                        }
                    </SelectAuto>
                    <Select id="markers" label="Filtrer par marqueur" value={selectedMarkers} onChange={(e) => handleInputChange(e, 'markers')}>
                        <option value="">- Choisissez -</option>
                        {
                            markers.map(marker => {
                                return (
                                    <option key={marker.id} selected={selectedMarkers === marker.id && true || false} value={marker.id}>{marker.name}</option>
                                )
                            })
                        }
                    </Select>
                    <Select id="sex" label="Filtrer par sexe" value={selectedSex} onChange={(e) => handleInputChange(e, 'sex')}>
                        <option value="">- Choisissez -</option>
                        {
                            sexArray.map((sex, id) => {
                                return (
                                    <option key={id} selected={selectedSex === id && true || false} value={id}>{sex}</option>
                                )
                            })
                        }
                    </Select>
                    <Select id="location" label="Filtrer par terrain" value={selectedLocation} onChange={(e) => handleInputChange(e, 'location.id')}>
                        <option value="">- Choisissez -</option>
                        {
                            tableData['locations'] && tableData['locations'].map((location) => {
                                return (
                                    <option key={location.id} selected={selectedLocation === location.id && true || false} value={location.id}>{location.fullName}</option>
                                )
                            })
                        }
                    </Select>
                    <Select id="birthday" label="Filtrer par âge" value={selectedBirthday} onChange={(e) => handleInputChange(e, 'birthday')}>
                        <option value="">- Choisissez -</option>
                        {
                            Object.keys(birthdayList).map(k => {
                                return (
                                    <option key={k} selected={selectedBirthday === k && true || false} value={k}>{birthdayList[k]}</option>
                                )
                            })
                        }
                    </Select>
                    <Select id="weight" label="Filtrer par poids" value={selectedWeight} onChange={(e) => handleInputChange(e, 'weight')}>
                        <option value="">- Choisissez -</option>
                        {
                            Object.keys(weightList).map(k => {
                                return (
                                    <option key={k} selected={selectedWeight === k && true || false} value={k}>{weightList[k]}</option>
                                )
                            })
                        }
                    </Select>
                </div>
            </Modal>
            <Modal isShowing={isModalShowing} hide={() => toggleModal('ModalAction')} title="Choisissez une action" id="ModalAction">
                <div class="d-grid gap-2">
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoMovement}>Déplacer</button>
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoMarker}>Marquer</button>
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoExit}>Sortie</button>
                    <button type="button" class="list-button btn btn-secondary" onClick={gotoOther}>Autre évènement</button>
                    {
                        eventsType &&
                        <div class="form-floating  mb-3">
                            <select class="form-control" id="eventsType" name="eventsType" onchange={(e) => handleEventsTypeChange(e)}>
                                <option value="">- Aucune -</option>
                                {
                                    eventsType.map((evt) => {
                                        return (
                                            <option key={evt.id} value={evt.id}>{evt.name}</option>
                                        )
                                    })
                                }
                            </select>
                            <label class="form-label" for="eventsType">Evènement type</label>
                        </div>
                    }
                </div>
            </Modal>
            <ActionButton id="toggleModalAction" idTable={'animals'} onClick={() => toggleModal('ModalAction')} />
        </div>
    );
}